const getBusinessPhone = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (business && business['Company Contact'] && business['Company Contact'].ID) {
    return business['Company Contact']['Phone Number'];
  }
  return null;
};

export default getBusinessPhone;



// WEBPACK FOOTER //
// ./src/utils/print/getBusinessPhone.js